import {BotaoImprimir, PaginaLogada} from "../../componentes";
import {useEffect, useState} from "react";
import {CirastServico} from "../../servicos";
import {exibirMensagemErro, formatarData, HttpVerbo, xfetch} from "../../util";
import {Card} from "../../componentes/card/Card";
import {useNavigate} from "react-router-dom";

export default function ListarConsultasCirast() {

  const navegacao = useNavigate()
  const [consultas, setConsultas] = useState([])
  const [isCarregando, setIsCarregando] = useState(false)
  const [filtro, setFiltro] = useState('')

  function buscarConsultas() {
    setIsCarregando(true)
    CirastServico.listarConsultasCirast()
      .then(res => res.json())
      .then(dados => setConsultas(dados))
      .catch(() => exibirMensagemErro("Erro ao buscar consultas"))
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    buscarConsultas()
  }, [])

  function imprimir(id) {
    // setIsCarregando(true)
    window.open('/impressaoCirast/'+id)
  }

  return (
    <PaginaLogada titulo="Listagem de consultas" isCarregando={isCarregando}>

      <div className="row">
        <Card className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 mb-5">
              <label>Filtro:</label>
              <input className="form-control" placeholder="Buscar" onChange={(e) => setFiltro(e.target.value)}/>
            </div>
          </div>
          <div className="col-lg-12">
            <table className="table table-stripped table-hover table-bordered">
            <thead>
            <tr>
              <th>Paciente</th>
              <th>Tipo</th>
              <th>Clinica</th>
              <th>Inicio validade</th>
              <th>Atendimentos</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
            </thead>
            <tbody>
              {consultas.filter(m => m.paciente.indexOf(filtro.toUpperCase()) > -1).map((v, k) => {
                return (
                  <tr key={k}>
                    <td>{v.paciente}</td>
                    <td>{v.tpAntedimento}</td>
                    <td>{v.clinicaCirast.nome}</td>
                    <td>{formatarData(v.dataInicioValidade)}</td>
                    <td>{v.qtdExecutado}/{v.qtdSolicitado}</td>
                    <td>
                      <span className={`badge rounded-pill ${isValidoAtendimento(v) ? 'bg-success' : 'bg-danger'}`} title="Tooltip on top">
                        {isValidoAtendimento(v) ? 'válido' : 'inválido'}
                      </span>
                    </td>
                    <td>
                      <BotaoImprimir onClick={() => imprimir(v.id)}/>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          </div>
        </Card>
      </div>
    </PaginaLogada>
  )

  function isValidoAtendimento(consulta) {
    return consulta.ativo
  }
}